(function () {
  'use strict';

  var IMAGE_SELECTOR = 'img[data-menu-src]';
  var DESKTOP_QUERY = '(min-width: 990px)';

  /**
   * Return the first direct child matching a class name.
   * This avoids using the newer :scope selector.
   */
  function getDirectChildByClass(parent, className) {
    var children;
    var index;

    if (!parent) return null;

    children = parent.children;

    for (index = 0; index < children.length; index += 1) {
      if (children[index].classList.contains(className)) {
        return children[index];
      }
    }

    return null;
  }

  /**
   * Return the direct summary element belonging to a details element.
   */
  function getDirectSummary(details) {
    var children;
    var index;

    if (!details) return null;

    children = details.children;

    for (index = 0; index < children.length; index += 1) {
      if (children[index].tagName === 'SUMMARY') {
        return children[index];
      }
    }

    return null;
  }

  /**
   * Load deferred mega-menu images only when their menu is opened.
   */
  function hydrateMenuImages(container) {
    var images;
    var index;
    var image;
    var source;
    var sourceSet;

    if (!container) return;

    images = container.querySelectorAll(IMAGE_SELECTOR);

    for (index = 0; index < images.length; index += 1) {
      image = images[index];
      source = image.getAttribute('data-menu-src');
      sourceSet = image.getAttribute('data-menu-srcset');

      if (sourceSet) {
        image.setAttribute('srcset', sourceSet.replace(/^\s+|\s+$/g, ''));
      }

      if (source) {
        image.setAttribute('src', source);
      }

      image.removeAttribute('data-menu-src');
      image.removeAttribute('data-menu-srcset');
      image.classList.add('is-menu-image-loaded');
    }
  }

  /**
   * Load desktop images when a shopper hovers, focuses or taps a menu.
   */
  function bindDesktopMenus(scope) {
    var items = scope.querySelectorAll('.header__nav-item');
    var index;

    for (index = 0; index < items.length; index += 1) {
      bindDesktopMenuItem(items[index]);
    }
  }

  function bindDesktopMenuItem(item) {
    var dropdown;
    var hydrate;

    if (!item || item.getAttribute('data-mp-menu-bound') === 'true') return;

    dropdown = getDirectChildByClass(item, 'header__nav-dropdown');
    if (!dropdown) return;

    hydrate = function () {
      hydrateMenuImages(dropdown);
    };

    item.addEventListener('mouseenter', hydrate);
    item.addEventListener('focusin', hydrate);
    item.addEventListener('pointerdown', hydrate);
    item.setAttribute('data-mp-menu-bound', 'true');
  }

  /**
   * Close one mobile category and restore its default state.
   */
  function closeMobileCategory(details, restoreFocus) {
    var summary;
    var panel;
    var scrollContainer;

    if (!details) return;

    summary = getDirectSummary(details);
    panel = summary ? summary.nextElementSibling : null;
    scrollContainer = details.closest
      ? details.closest('[data-scroll-container]')
      : null;

    details.removeAttribute('open');
    details.classList.remove('menu-opening');

    if (scrollContainer) {
      scrollContainer.classList.remove('has-open-submenu');
    }

    if (summary) {
      summary.setAttribute('aria-expanded', 'false');
    }

    if (panel) {
      panel.setAttribute('tabindex', '-1');
      panel.scrollTop = 0;
    }

    if (restoreFocus && summary) {
      summary.focus();
    }
  }

  /**
   * Bind the mobile drawer, explicit Back to Menu buttons and Escape behavior.
   */
  function bindMobileDrawer(drawer) {
    var rootDetails;
    var rootSummary;
    var categoryDetails;
    var index;

    if (!drawer || drawer.getAttribute('data-mp-menu-bound') === 'true') return;

    rootDetails = getDirectChildByClass(drawer, 'header-drawer__container');
    rootSummary = getDirectSummary(rootDetails);
    categoryDetails = drawer.querySelectorAll('[data-mobile-menu-details]');

    for (index = 0; index < categoryDetails.length; index += 1) {
      bindMobileCategory(categoryDetails[index], categoryDetails);
    }

    if (rootSummary) {
      rootSummary.addEventListener('click', function () {
        var categoryIndex;

        if (!rootDetails.hasAttribute('open')) {
          hydrateMenuImages(drawer);
          return;
        }

        for (
          categoryIndex = 0;
          categoryIndex < categoryDetails.length;
          categoryIndex += 1
        ) {
          closeMobileCategory(categoryDetails[categoryIndex], false);
        }
      });
    }

    drawer.addEventListener('keydown', function (event) {
      var categoryIndex;
      var openCategory;
      var openSummary;

      if (event.key !== 'Escape' && event.key !== 'Esc') return;

      for (
        categoryIndex = categoryDetails.length - 1;
        categoryIndex >= 0;
        categoryIndex -= 1
      ) {
        if (categoryDetails[categoryIndex].hasAttribute('open')) {
          openCategory = categoryDetails[categoryIndex];
          break;
        }
      }

      if (!openCategory) return;

      event.preventDefault();
      event.stopPropagation();

      openSummary = getDirectSummary(openCategory);

      if (openSummary) {
        openSummary.click();
      } else {
        closeMobileCategory(openCategory, true);
      }
    });

    drawer.setAttribute('data-mp-menu-bound', 'true');
  }

  function bindMobileCategory(details, allCategories) {
    var summary = getDirectSummary(details);
    var panel = summary ? summary.nextElementSibling : null;
    var backButton = panel
      ? panel.querySelector('[data-menu-back]')
      : null;

    if (!summary || !panel) return;

    summary.addEventListener('click', function () {
      var isOpening = !details.hasAttribute('open');
      var index;
      var otherDetails;
      var otherSummary;

      if (!isOpening) return;

      for (index = 0; index < allCategories.length; index += 1) {
        otherDetails = allCategories[index];

        if (
          otherDetails !== details &&
          otherDetails.hasAttribute('open')
        ) {
          otherSummary = getDirectSummary(otherDetails);

          if (otherSummary) {
            otherSummary.click();
          } else {
            closeMobileCategory(otherDetails, false);
          }
        }
      }

      hydrateMenuImages(panel);

      window.setTimeout(function () {
        if (details.hasAttribute('open') && backButton) {
          try {
            backButton.focus({ preventScroll: true });
          } catch (error) {
            backButton.focus();
          }
        }
      }, 100);
    });

    if (backButton) {
      backButton.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        if (details.hasAttribute('open')) {
          summary.click();
        } else {
          closeMobileCategory(details, false);
        }

        window.setTimeout(function () {
          summary.focus();
        }, 450);
      });
    }
  }

  function bindMobileMenus(scope) {
    var drawers = scope.querySelectorAll('header-drawer');
    var index;

    for (index = 0; index < drawers.length; index += 1) {
      bindMobileDrawer(drawers[index]);
    }
  }

  /**
   * Close mobile navigation if the viewport changes to desktop.
   */
  function bindResizeSafety() {
    var mediaQuery;
    var closeMobileDrawers;

    if (window.mpHeaderResizeBound) return;

    mediaQuery = window.matchMedia(DESKTOP_QUERY);

    closeMobileDrawers = function () {
      var drawers;
      var drawerIndex;
      var drawer;
      var rootDetails;
      var rootSummary;
      var openCategories;
      var categoryIndex;

      if (!mediaQuery.matches) return;

      drawers = document.querySelectorAll('header-drawer');

      for (drawerIndex = 0; drawerIndex < drawers.length; drawerIndex += 1) {
        drawer = drawers[drawerIndex];
        rootDetails = getDirectChildByClass(
          drawer,
          'header-drawer__container'
        );
        rootSummary = getDirectSummary(rootDetails);
        openCategories = drawer.querySelectorAll(
          '[data-mobile-menu-details][open]'
        );

        for (
          categoryIndex = 0;
          categoryIndex < openCategories.length;
          categoryIndex += 1
        ) {
          closeMobileCategory(openCategories[categoryIndex], false);
        }

        if (
          rootDetails &&
          rootDetails.hasAttribute('open') &&
          typeof drawer.closeMenuDrawer === 'function'
        ) {
          drawer.closeMenuDrawer(new Event('resize'), rootSummary);
        } else if (rootDetails) {
          rootDetails.removeAttribute('open');
          rootDetails.classList.remove('menu-opening');
        }
      }
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', closeMobileDrawers);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(closeMobileDrawers);
    }

    window.mpHeaderResizeBound = true;
  }

  function initializeHeaderNavigation(scope) {
    var initializationScope = scope || document;

    bindDesktopMenus(initializationScope);
    bindMobileMenus(initializationScope);
    bindResizeSafety();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initializeHeaderNavigation(document);
    });
  } else {
    initializeHeaderNavigation(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initializeHeaderNavigation(event.target);
  });
})();
